import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import './section-product-features.scss';

const SectionProductFeatures = ({ contentInfo }) => {

    const [slidesNumber, setSlidesNumber] = useState(0)
    const [currentSlide, setCurrenSlide] = useState(0)

    useEffect(() => {
        setSlidesNumber(contentInfo.caracteristicasDelProducto ? contentInfo.caracteristicasDelProducto.length : 0)
    }, [])

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-product-features__feature-description">{next}</p>
        }
    };

    const getFeatures = () => {

        const featureList = contentInfo.caracteristicasDelProducto.map((info, index) => {
            return (
                <div key={index} className="f-m-product-features__feature">
                    <div className="f-m-product-features__feature-background" />
                    <div className="f-m-product-features__feature-content">
                        <div className="f-m-product-features__feature-image">
                            <GatsbyImage
                                image={info.imagenCategorias[0].gatsbyImageData}
                                alt={info.imagenCategorias[0].description}
                                className="f-m-product-features__feature-image-inner"
                            />
                        </div>
                        <h3 className="f-m-product-features__feature-title">
                            {info.nombreDeLaCategoria}
                        </h3>
                        {info.descripcionDeLaCategoria.raw && documentToReactComponents(JSON.parse(info.descripcionDeLaCategoria.raw), options)}
                    </div>
                </div>
            )
        })

        return featureList

    }

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className={"f-m-slider-product-features-next " + (currentSlide >= (slidesNumber - 3) ? "__hide" : "")}
                onClick={onClick}
            />
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;

        return (
            <span
                className={"f-m-slider-product-features-prev " + (currentSlide === 0 ? "__hide" : "")}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 250,
        draggable: false,
        arrows: true,
        afterChange: current => setCurrenSlide(current),
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: true,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    arrows: true
                }
            }]
    }

    return (
        <section className="f-m-product-features">
            <div className="f-m-product-features__background" />
            <div className="f-m-product-features__content">
                <div className="f-m-product-features__slider-container">
                    <Slider {...settings} className="f-m-product-features__slider">
                        {
                            contentInfo.caracteristicasDelProducto &&
                            getFeatures()
                        }
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default SectionProductFeatures
